import { Navigate, Outlet } from 'react-router-dom'

import { paths } from '@/app/router/paths'
import { type AdminArea, useAdminArea } from '@/features/admin/hooks/useAdminArea'

/**
 * Sits under the tenant `AreaRoute`. A session whose role has no such panel is
 * sent to the pipeline: every request on the page would be refused anyway.
 */
export function AdminRoute({ area }: { area: Exclude<AdminArea, null> }) {
  const current = useAdminArea()

  if (current !== area) return <Navigate to={paths.pipeline} replace />

  return <Outlet />
}
